export default {
  path: '/einstellungen',
  name: 'einstellungen',
  component: () => import('./StepEinstellungen.vue'),
  meta: {
    step: {
      label: 'Einstellungen',
      sublabel: 'Öffentlich oder Privat',
      showInHeader: true,
      isActive: true,
      requiresEnterValidation: true,
      allowSave: true,
      get store() {
        return useStepStore('einstellungen')
      },
    },
  },
} as const satisfies OwnbitConfigurator.Steps.Route<'einstellungen'>
